import { createSlice } from '@reduxjs/toolkit';

/**
 * Initial state for the pools module in the Redux store.
 */
const initialState = {
    poolList: null,             // List of all available or fetched pools
    poolDetails: null,          // Detailed info of a single selected pool
    selectedPool: null,         // Currently selected pool object
    poolChat: null,             // Chat history or discussion thread for a pool
    isSuspendPopup: false,      // Boolean flag to show/hide suspend confirmation popup
    refundData: null            // Data related to refund process for a pool
};

/**
 * Redux slice for managing pools-related state.
 * Includes reducers to manage list, details, selection, UI popups, and refund data.
 */
const poolsSlice = createSlice({
    name: 'pools',
    initialState,
    reducers: {
        /**
         * Sets the list of pools.
         */
        setPoolList: (state, action) => {
            state.poolList = action.payload;
        },

        /**
         * Sets detailed information for a selected pool.
         */
        setPoolDetails: (state, action) => {
            state.poolDetails = action.payload;
        },

        /**
         * Sets the currently selected pool (for editing or viewing).
         */
        setSelectedPool: (state, action) => {
            state.selectedPool = action.payload;
        },

        /**
         * Sets the chat data associated with a pool.
         */
        setPoolChat: (state, action) => {
            state.poolChat = action.payload;
        },

        /**
         * Toggles the suspend confirmation popup state.
         */
        setIsSuspendPopup: (state, action) => {
            state.isSuspendPopup = action.payload;
        },

        /**
         * Sets the refund-related data for a specific pool.
         */
        setRefundData: (state, action) => {
            state.refundData = action.payload;
        }
    },

    /**
     * Optional: Reset the state using a plain action string (should ideally use a typed action).
     */
    extraReducers: (builder) => {
        builder.addCase('RESET_STATE', () => initialState);
    }
});

// Export actions for use in components
export const {
    setPoolList,
    setPoolDetails,
    setSelectedPool,
    setPoolChat,
    setIsSuspendPopup,
    setRefundData
} = poolsSlice.actions;

// Export the reducer to be included in the Redux store
export default poolsSlice.reducer;
